
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.712 11.778l-6.034 6.085a.977.977 0 01-1.39 0 .997.997 0 010-1.401l5.34-5.385-5.34-5.385a.997.997 0 010-1.402.977.977 0 011.39 0l6.034 6.086a.992.992 0 01.288.7.992.992 0 01-.288.702z","fill":"#4E4E4E","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_arrow_right.svg